import makeStyles from "@mui/styles/makeStyles";
import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

const defaultText = {
  fontFamily: "Manrope",
  fontSize: 12,
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: 0.4,
  color: colors.gray600,
  "@media screen and (max-width: 1024px)": {
    fontSize: 12,
  },
};

export const Title = styled("span")(() => ({
  fontFamily: "Manrope",
  fontWeight: 600,
  fontSize: 16,
  lineHeight: "24px",
  letterSpacing: 0.15,
}));

export const InfoCard = styled("div")(() => ({
  position: "relative",
  width: "100%",
  height: "auto",
  top: 0,
  right: 0,

  backgroundColor: colors.gray100,
  borderRadius: 8,

  display: "flex",
  alignItems: "flex-start",
  padding: 12,
}));

export const InfoCardColumn = styled("div")(() => ({
  alignSelf: "stretch",
}));

export const InfoCardBody = styled("div")(() => ({
  display: "flex",
  gap: 8,
  flex: "1 0 0",
  alignSelf: "stretch",
  flexDirection: "column",
  padding: "0px 12px 8px 12px",
}));

interface TextProps {
  hasErrors?: boolean;
}
export const Text = styled("span")(({ hasErrors }: TextProps) => ({
  ...defaultText,
  lineHeight: "16px",
  color: hasErrors ? colors.error600 : defaultText.color,
}));

export const BodyText = styled("div")(() => ({
  "& > span": {
    ...defaultText,
  },
}));

interface TrackingWrapperProps {
  hasErrors?: boolean;
}
export const TrackingWrapperGrid = styled(Grid)(({ hasErrors }: TrackingWrapperProps) => ({
  backgroundColor: hasErrors ? colors.error50 : colors.gray50,
  marginLeft: "0px !important",
  padding: "8px 16px 16px 0",
  borderRadius: 8,
  border: `1px solid ${hasErrors ? colors.error600 : colors.gray200}`,
  width: "100% !important",
}));

export const BodyItem = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: 4,

  "& > span": {
    ...defaultText,
    fontWeight: 700,
  },
}));

export const ReferenceInputWrapper = styled("div")({
  position: "relative",
});

export const ReferenceLoading = styled("div")({
  position: "absolute",
  top: 35,
  right: 15,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const styles = makeStyles(() => ({
  positionRelative: {
    position: "relative",
    paddingBottom: 0,

    "@media screen and (max-width: 768px)": {
      paddingBottom: "0 !important",
      paddingTop: 12,
    },
  },
  options: {
    display: "flex",
    flexDirection: "row",
    gap: 16,
  },
  trackingWrapper: {
    backgroundColor: colors.gray50,
    marginLeft: "0px !important",
    padding: "8px 16px 16px 0",
    borderRadius: 8,
    border: `1px solid ${colors.gray200}`,
    width: "100% !important",
  },
}));

export default styles;
